"use strict";

module.exports = function () {
  if (this.opts.filterByColumn) {
    var query = {};

    for (var key in this.query) {
      query[key] = '';
    }
  } else {
    var query = '';
  }

  this.setFilter(query);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/reset-query.js
// module id = i8M6
// module chunks = 0